import React from 'react'
import { IconGraphRightArrow, IconChevronLeft } from '@edulastic/icons'
import { Container } from './styled'

const PassageDivider = ({ viewComponent, collapseDirection, onChange }) => {
  const handleOnClick = (dir) => () => {
    if (dir !== collapseDirection) {
      onChange(dir)
    }
  }

  const handleKeyPress = (e, dir) => {
    if (e.key === 'Enter') {
      handleOnClick(dir)()
    }
  }

  return (
    <Container
      dir={collapseDirection}
      isFixed={viewComponent === 'itemDetail'}
      data-cy="dividerButton"
      data-test={collapseDirection}
    >
      <div
        className="collapse left"
        onClick={handleOnClick('left')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => handleKeyPress(e, 'left')}
        aria-label="Flip the question to left"
      >
        <IconChevronLeft />
      </div>
      <div
        className="vertical-lines"
        onClick={handleOnClick('')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => handleKeyPress(e, '')}
        aria-label="Flip the question"
      >
        <div className="vertical-line" />
        <div className="vertical-line" />
        <div className="vertical-line" />
      </div>
      <div
        className="collapse right"
        onClick={handleOnClick('right')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => handleKeyPress(e, 'right')}
        aria-label="Flip the question to right"
      >
        <IconGraphRightArrow />
      </div>
    </Container>
  )
}

export default PassageDivider
